import { render, staticRenderFns } from "./Prestations.vue?vue&type=template&id=c5398a2a&"
import script from "./Prestations.vue?vue&type=script&lang=js&"
export * from "./Prestations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports